import ActionFormContext from '../ActionFormContext'
import { type FieldValues, useFormContext } from 'react-hook-form'
import { useContext } from 'react'
import type { UseActionFormReturn } from '../useActionForm'

function useActionFormContext<T extends FieldValues, TOperationSuccessResult>() {
  const { setBusy, submit, defaultValues } = useContext(ActionFormContext) as Pick<
    UseActionFormReturn<T, TOperationSuccessResult>,
    'setBusy' | 'submit' | 'defaultValues'
  >
  const context = useFormContext<T>()

  return {
    ...context,
    setBusy,
    submit,
    defaultValues,
  }
}

export default useActionFormContext
